<mat-chip-list class="mat-chip-list-stacked">
  <mat-chip *ngFor="let reminder of reminders"
            class="reminder-{{reminder.dossier_obj.state}}"
            (click)="edit(reminder.dossier_obj.uuid)"
            matTooltip="{{ reminder.dossier_obj.intitule_poste_label }} {{ reminder.dossier_obj.intitule_poste_autre || '' }}"
  >
    {{ reminder.dossier_obj.reference }}
  </mat-chip>
</mat-chip-list>
